<template>
  <section class="grid-flex column">
    <!-- filters -->
    <div class="flex-1 flex column w100 middle">
      <div class="flex-1 w100">
        <div class="flex middle">
          <div class="flex-1">
            <router-link
              :to="{
                name: 'VSLNew',
                params: {},
              }"
            >
              <div class="button primary">CRIAR VSL</div>
            </router-link>
          </div>
          <div class="flex-1 filters-group-holder between">
            <div class="flex end">
              <div style="margin-right: 16px;" class="flex column no-mobile">
                <label>Atualizar dados</label>
                <div class="flex end w100" style="margin-top:12px">
                  <div @click="forceRefreshData()" class="button secondary">
                    <i class="fas fa-sync-alt"></i>
                  </div>
                </div>
              </div>
              <ltk-date-picker
                label="Filtro de data"
                v-model="filters.data.date"
                :loading="loading"
              ></ltk-date-picker>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- pagination -->

    <div class="flex-1 flex row w100 middle">
      <div class="flex w100 end filters-groupo-holder">
        <div class="flex between middle">
          <paginate
            :containerClass="'pagination'"
            :page-count="totalPages"
            v-model="page"
            :page-range="5"
            :click-handler="clickCallback"
            :prev-text="'Anterior'"
            :next-text="'Próxima'"
          ></paginate>
        </div>
      </div>
    </div>

    <div class="flex-1 w100 margin-to-l">
      <ul>
        <li v-for="(vsl, index) in vsls" :key="index">
          <div class="box margin-top-m">
            <div class="box-content">
              <div class="flex middle row">
                <div class="flex-3">
                  <div class="flex middle row">
                    <div class="flex-1 name margin-top-s">
                      <p>
                        {{ vsl.title }}
                      </p>
                      <small>{{ vsl.url_checkout }}</small>
                    </div>
                    <div class="flex-2 margin-top-s">
                      <div class="flex details between">
                        <div>
                          <p>Players</p>
                          <small>{{ vsl.stats.players | number }}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="action">
                  <div class="flex end">
                    <router-link
                      :to="{
                        name: 'VSLDetail',
                        params: { vsl_id: vsl.id },
                      }"
                    >
                      <div class="button primary">Relatório</div>
                    </router-link>
                    <router-link
                      :to="{
                        name: 'VSLEdit',
                        params: { vsl_id: vsl.id },
                      }"
                    >
                      <div class="button secondary margin-left">
                        <i class="fas fa-edit"></i>
                      </div>
                    </router-link>
                    <div class="button secondary margin-left">
                      <i class="fas fa-trash-alt"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div v-if="isEmpty" class="box center-text margin-top-l">
        <div class="box-content">
          <p>
            Não encontramos nenhuma vsl criada.
          </p>
        </div>
      </div>

      <div v-if="loading">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>

      <!-- pagination -->
      <div class="flex-1 flex row w100 middle">
        <div class="flex w100 end filters-groupo-holder">
          <div class="flex between middle">
            <paginate
              :containerClass="'pagination'"
              :page-count="totalPages"
              v-model="page"
              :page-range="5"
              :click-handler="clickCallback"
              :prev-text="'Anterior'"
              :next-text="'Próxima'"
            ></paginate>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import moment from "moment";
moment.locale("pt-br");

import { getVsls } from "@/services/vsl";
import ltkDatePicker from "@/components/datepicker/LtkDatePicker";

export default {
  name: "vsl",
  components: { ltkDatePicker },
  data() {
    return {
      loading: false,
      filters: {
        data: {
          date: [
            moment()
              .add(-0, "d")
              .startOf("day")
              .toDate(),
            moment()
              .startOf("day")
              .toDate(),
          ],
          search: "",
        },
        list: {},
      },
      vsls: [],
      totalVsl: 0,
      offset: 20,
      page: 1,
      refreshTime: 60,
      refreshInterval: null,
    };
  },
  mounted() {
    this.getVsls();
    // this.refreshInterval = setInterval(this.getVsls, this.refreshTime * 1000);
  },
  destroyed() {
    clearInterval(this.refreshInterval);
  },
  computed: {
    isEmpty() {
      // return !this.loading && this.vsls && this.vsls.length === 0;
      return this.totalVsl === 0 && !this.loading;
    },
    totalPages() {
      let valueMode = this.totalVsl % this.offset;
      let value = this.totalVsl / this.offset;

      let pages = 1;

      if (valueMode == 0) {
        pages = value;
      } else {
        pages = parseInt(value) + 1;
      }

      return pages;
    },
  },
  watch: {
    "filters.data": {
      deep: true,
      handler() {
        this.vsls = [];
        this.getVsls();
      },
    },
    page: {
      handler() {
        this.vsls = [];
        this.getVsls();
      },
    },
  },
  methods: {
    forceRefreshData() {
      this.getVsls();
    },
    getVsls() {
      this.loading = true;

      const date = this.filters.data.date;
      let params = {
        start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
        end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
        group_by: this.filters.data.group_by,
        search: this.filters.data.search,
        page: this.page,
        offset: this.offset,
      };
      getVsls(params)
        .then((result) => {
          this.vsls = result.vsls.map((p) => {
            return {
              id: p.id,
              public_id: p.id,
              title: p.title,
              url_checkout: p.url_checkout,
              stats: {
                players: p.players,
              },
            };
          });
          this.totalVsl = result.total;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao buscar VSL",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
li {
  list-style-type: none;
}

.details {
  > div {
    margin-right: 34px;
    p {
      line-height: 20px;
    }
    small {
      font-weight: 800;
    }
  }
}

.name {
  small {
    font-weight: 800;
  }
}

.profit {
  .green {
    color: green;
  }
  .red {
    color: red;
  }
}

@media screen and (max-width: 1024px) {
  .details {
    flex-direction: column;

    > div {
      margin-right: 8px;
      margin-top: 8px;
      display: flex;
      align-items: center;

      p::after {
        content: ":";
      }
      small {
        margin-left: 8px;
      }
    }
  }
  .action {
    margin-top: 16px;
  }
}

.margin-left {
  margin-left: 8px;
}
</style>
